import type {
  TireHotelAttachWheelSetApiData,
  TireHotelAttachWheelSetApiResponses,
  TireHotelCancelApiData,
  TireHotelCancelApiResponses,
  TireHotelEventsListApiData,
  TireHotelEventsListApiResponses,
  TireHotelFilterCountsApiData,
  TireHotelFilterCountsApiResponses,
  TireHotelGetApiData,
  TireHotelGetApiResponses,
  TireHotelImportApiData,
  TireHotelImportApiResponses,
  TireHotelImportPreviewApiData,
  TireHotelImportPreviewApiResponses,
  TireHotelIssuesGetApiData,
  TireHotelIssuesGetApiResponses,
  TireHotelListApiData,
  TireHotelListApiResponses,
  TireHotelListForCustomerApiData,
  TireHotelListForCustomerApiResponses,
  TireHotelListForPartnerApiData,
  TireHotelListForPartnerApiResponses,
  TireHotelLocationCreateApiData,
  TireHotelLocationCreateApiResponses,
  TireHotelLocationDeleteApiData,
  TireHotelLocationDeleteApiResponses,
  TireHotelLocationGetApiData,
  TireHotelLocationGetApiResponses,
  TireHotelLocationGoogleOpeningHoursPostApiData,
  TireHotelLocationGoogleOpeningHoursPostApiResponses,
  TireHotelLocationListApiData,
  TireHotelLocationListApiResponses,
  TireHotelLocationMinimalListApiData,
  TireHotelLocationMinimalListApiResponses,
  TireHotelLocationNoteAttachmentDeleteApiData,
  TireHotelLocationNoteAttachmentDeleteApiResponses,
  TireHotelLocationNoteAttachmentsBulkCreateApiData,
  TireHotelLocationNoteAttachmentsBulkCreateApiResponses,
  TireHotelLocationNoteCreateApiData,
  TireHotelLocationNoteCreateApiResponses,
  TireHotelLocationNoteDeleteApiData,
  TireHotelLocationNoteDeleteApiResponses,
  TireHotelLocationNoteListApiData,
  TireHotelLocationNoteListApiResponses,
  TireHotelLocationNotePatchApiData,
  TireHotelLocationNotePatchApiResponses,
  TireHotelLocationOpeningHoursCreateApiData,
  TireHotelLocationOpeningHoursCreateApiResponses,
  TireHotelLocationOpeningHoursUpdateApiData,
  TireHotelLocationOpeningHoursUpdateApiResponses,
  TireHotelLocationPublicHolidayOpeningHoursPostApiData,
  TireHotelLocationPublicHolidayOpeningHoursPostApiResponses,
  TireHotelLocationUpdateApiData,
  TireHotelLocationUpdateApiResponses,
  TireHotelOverviewGetApiData,
  TireHotelOverviewGetApiResponses,
  TireHotelPatchApiData,
  TireHotelPatchApiResponses,
  TireHotelRehomeCancelApiData,
  TireHotelRehomeCancelApiResponses,
  TireHotelRehomeCreateApiData,
  TireHotelRehomeCreateApiResponses,
  TireHotelRehomeGetApiData,
  TireHotelRehomeGetApiResponses,
  TireHotelRehomeListApiData,
  TireHotelRehomeListApiResponses,
  TireHotelRehomePublicApproveApiData,
  TireHotelRehomePublicApproveApiResponses,
  TireHotelRehomePublicGetApiData,
  TireHotelRehomePublicGetApiResponses,
  TireHotelRehomePublicRejectApiData,
  TireHotelRehomePublicRejectApiResponses,
  TireHotelRehomeSendApiData,
  TireHotelRehomeSendApiResponses,
  TireHotelRenewalProposalCreateApiData,
  TireHotelRenewalProposalCreateApiResponses,
  TireHotelTerminateApiData,
  TireHotelTerminateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

export const getTireHotelLocationUrls = {
  getPaginatedTireHotelLocations: dataEndpoint<TireHotelLocationListApiData, TireHotelLocationListApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotel-locations/', queryParams)
  }),
  getPaginatedMinimalTireHotelLocations: dataEndpoint<
    TireHotelLocationMinimalListApiData,
    TireHotelLocationMinimalListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('tire-hotel-locations/minimal/', queryParams)
  }),
  getTireHotelLocation: dataEndpoint<TireHotelLocationGetApiData, TireHotelLocationGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`tire-hotel-locations/${pk}/`)
  }),
  postTireHotelLocation: responseEndpoint<TireHotelLocationCreateApiData, TireHotelLocationCreateApiResponses>({
    getUrl: () => apiUrl('tire-hotel-locations/'),
    getBody: (data) => data
  }),
  patchTireHotelLocation: responseEndpoint<TireHotelLocationUpdateApiData, TireHotelLocationUpdateApiResponses>({
    getUrl: ({ pk }) => apiUrl(`tire-hotel-locations/${pk}/`),
    getBody: ({ pk: _, ...data }) => data
  }),
  deleteTireHotelLocation: dataEndpoint<TireHotelLocationDeleteApiData, TireHotelLocationDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`tire-hotel-locations/${pk}/`)
  }),
  postOpeningHoursTireHotelLocation: responseEndpoint<
    TireHotelLocationOpeningHoursCreateApiData,
    TireHotelLocationOpeningHoursCreateApiResponses
  >({
    getUrl: () => apiUrl('tire-hotel-locations/opening-hours/'),
    getBody: (data) => data
  }),
  postTireHotelLocationGoogleOpeningHours: responseEndpoint<
    TireHotelLocationGoogleOpeningHoursPostApiData,
    TireHotelLocationGoogleOpeningHoursPostApiResponses
  >({
    getUrl: ({ tireHotelLocationId }) => apiUrl(`tire-hotel-locations/${tireHotelLocationId}/google-opening-hours/`),
    getBody: ({ tireHotelLocationId: _, ...body }) => body
  }),
  postTireHotelLocationPublicHolidayOpeningHours: responseEndpoint<
    TireHotelLocationPublicHolidayOpeningHoursPostApiData,
    TireHotelLocationPublicHolidayOpeningHoursPostApiResponses
  >({
    getUrl: ({ tireHotelLocationId }) =>
      apiUrl(`tire-hotel-locations/${tireHotelLocationId}/public-holiday-opening-hours/`)
  }),
  patchOpeningHoursTireHotelLocation: responseEndpoint<
    TireHotelLocationOpeningHoursUpdateApiData,
    TireHotelLocationOpeningHoursUpdateApiResponses
  >({
    getUrl: ({ pk }) => apiUrl(`tire-hotel-locations/opening-hours/${pk}/`),
    getBody: ({ pk: _, ...data }) => data
  }),
  getTireHotelLocationNotes: dataEndpoint<TireHotelLocationNoteListApiData, TireHotelLocationNoteListApiResponses>({
    getUrl: ({ tireHotelLocationId, ...queryParams }) =>
      apiUrl('tire-hotel-location-notes/', { tireHotelLocationId, ...queryParams })
  }),
  postTireHotelLocationNote: responseEndpoint<
    TireHotelLocationNoteCreateApiData,
    TireHotelLocationNoteCreateApiResponses
  >({
    getUrl: () => apiUrl('tire-hotel-location-notes/'),
    getBody: (data) => data
  }),
  patchTireHotelLocationNote: responseEndpoint<
    TireHotelLocationNotePatchApiData,
    TireHotelLocationNotePatchApiResponses
  >({
    getUrl: ({ tireHotelLocationNoteId }) => apiUrl(`tire-hotel-location-notes/${tireHotelLocationNoteId}/`),
    getBody: (data) => data
  }),
  deleteTireHotelLocationNote: dataEndpoint<
    TireHotelLocationNoteDeleteApiData,
    TireHotelLocationNoteDeleteApiResponses
  >({
    getUrl: ({ tireHotelLocationNoteId }) => apiUrl(`tire-hotel-location-notes/${tireHotelLocationNoteId}/`)
  }),
  postTireHotelLocationNoteAttachmentsBulk: responseEndpoint<
    TireHotelLocationNoteAttachmentsBulkCreateApiData,
    TireHotelLocationNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ tireHotelLocationNoteId }) =>
      apiUrl(`tire-hotel-location-notes/${tireHotelLocationNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteTireHotelLocationNoteAttachment: dataEndpoint<
    TireHotelLocationNoteAttachmentDeleteApiData,
    TireHotelLocationNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ tireHotelLocationNoteId, attachmentId }) =>
      apiUrl(`tire-hotel-location-notes/${tireHotelLocationNoteId}/attachments/${attachmentId}/`)
  })
};

export const getTireHotelUrls = {
  getPaginatedTireHotels: dataEndpoint<TireHotelListApiData, TireHotelListApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotels/', queryParams)
  }),
  getTireHotelFilterCounts: dataEndpoint<TireHotelFilterCountsApiData, TireHotelFilterCountsApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotels/filter-counts/', queryParams)
  }),
  getTireHotelsForPartner: dataEndpoint<TireHotelListForPartnerApiData, TireHotelListForPartnerApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotels/for-partner/', queryParams)
  }),
  getTireHotelsForCustomer: dataEndpoint<TireHotelListForCustomerApiData, TireHotelListForCustomerApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotels/for-customer/', queryParams)
  }),
  getTireHotelOverview: dataEndpoint<TireHotelOverviewGetApiData, TireHotelOverviewGetApiResponses>({
    getUrl: ({ serviceDepartmentIds }) => apiUrl('tire-hotels/overview/', { serviceDepartmentIds })
  }),
  getTireHotelIssues: dataEndpoint<TireHotelIssuesGetApiData, TireHotelIssuesGetApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotels/issues/', queryParams)
  }),
  getTireHotel: dataEndpoint<TireHotelGetApiData, TireHotelGetApiResponses>({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/`)
  }),
  getPaginatedTireHotelEvents: dataEndpoint<TireHotelEventsListApiData, TireHotelEventsListApiResponses>({
    getUrl: ({ tireHotelId, ...queryParams }) => apiUrl(`tire-hotels/${tireHotelId}/events/`, queryParams)
  }),
  patchTireHotel: responseEndpoint<TireHotelPatchApiData, TireHotelPatchApiResponses>({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/`),
    getBody: ({ tireHotelId: _, ...body }) => body
  }),
  postTireHotelCancel: responseEndpoint<TireHotelCancelApiData, TireHotelCancelApiResponses>({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/cancel/`),
    getBody: ({ tireHotelId: _, ...body }) => body
  }),
  postTireHotelTerminate: responseEndpoint<TireHotelTerminateApiData, TireHotelTerminateApiResponses>({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/terminate/`),
    getBody: ({ tireHotelId: _, ...body }) => body
  }),
  postTireHotelRenewalProposal: responseEndpoint<
    TireHotelRenewalProposalCreateApiData,
    TireHotelRenewalProposalCreateApiResponses
  >({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/renewal-proposal/`)
  }),
  getPaginatedTireHotelRehomes: dataEndpoint<TireHotelRehomeListApiData, TireHotelRehomeListApiResponses>({
    getUrl: (queryParams) => apiUrl('tire-hotels/rehomes/', queryParams)
  }),
  getTireHotelRehome: dataEndpoint<TireHotelRehomeGetApiData, TireHotelRehomeGetApiResponses>({
    getUrl: ({ rehomeId }) => apiUrl(`tire-hotels/rehomes/${rehomeId}/`)
  }),
  postTireHotelRehome: responseEndpoint<TireHotelRehomeCreateApiData, TireHotelRehomeCreateApiResponses>({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/rehomes/`),
    getBody: ({ tireHotelId: _, ...body }) => body
  }),
  postTireHotelRehomeSend: responseEndpoint<TireHotelRehomeSendApiData, TireHotelRehomeSendApiResponses>({
    getUrl: ({ rehomeId }) => apiUrl(`tire-hotels/rehomes/${rehomeId}/send/`),
    getBody: () => ({})
  }),
  postTireHotelRehomeCancel: responseEndpoint<TireHotelRehomeCancelApiData, TireHotelRehomeCancelApiResponses>({
    getUrl: ({ rehomeId }) => apiUrl(`tire-hotels/rehomes/${rehomeId}/cancel/`),
    getBody: () => ({})
  }),
  postTireHotelImportPreview: responseEndpoint<TireHotelImportPreviewApiData, TireHotelImportPreviewApiResponses>({
    getUrl: () => apiUrl('tire-hotels/import/preview/'),
    getBody: (body) => body
  }),
  postTireHotelImport: responseEndpoint<TireHotelImportApiData, TireHotelImportApiResponses>({
    getUrl: () => apiUrl('tire-hotels/import/'),
    getBody: (body) => body
  }),
  postTireHotelAttachWheelSet: responseEndpoint<TireHotelAttachWheelSetApiData, TireHotelAttachWheelSetApiResponses>({
    getUrl: ({ tireHotelId }) => apiUrl(`tire-hotels/${tireHotelId}/attach-wheel-set/`),
    getBody: ({ tireHotelId: _, ...body }) => body
  }),
  getTireHotelRehomePublic: dataEndpoint<TireHotelRehomePublicGetApiData, TireHotelRehomePublicGetApiResponses>({
    getUrl: ({ slug }) => apiUrl(`tire-hotels/rehomes/public/${slug}/`)
  }),
  postTireHotelRehomePublicApprove: responseEndpoint<
    TireHotelRehomePublicApproveApiData,
    TireHotelRehomePublicApproveApiResponses
  >({
    getUrl: ({ slug }) => apiUrl(`tire-hotels/rehomes/public/${slug}/approve/`),
    getBody: () => ({})
  }),
  postTireHotelRehomePublicReject: responseEndpoint<
    TireHotelRehomePublicRejectApiData,
    TireHotelRehomePublicRejectApiResponses
  >({
    getUrl: ({ slug }) => apiUrl(`tire-hotels/rehomes/public/${slug}/reject/`),
    getBody: () => ({})
  })
};
